<!-- Progress bar -->
<div *ngIf="isAdmin && accountType === 5" class="success-progress-bar-container overflow-hidden">
  <ng-container *ngIf="(isBarLoading$ | async) === false; else loading">
    <mat-expansion-panel class="overflow-visible" [expanded]="successCenterExpanded" (opened)="onSuccessCenterToggle(true)" (closed)="onSuccessCenterToggle(false)">
      <mat-expansion-panel-header class="left-panel-header" [matTooltip]="achievementLevel<4 && successCenterExpanded ? 'Hide Progress Bar for 30 days' : ''">
        <mat-panel-title>
          <h5 class="mb-0 achievement-title">Your SalesIntel Achievements</h5>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <p class="mb-2">
        {{ achievementLevel | achievementMessage }}
        <a [routerLink]="['/', { outlets: { modal: [modalNavigationEnum.SUCCESS_CENTER] } }]">
          {{ achievementLevel === 4 ? 'Here’s what you’ve done with SalesIntel.' : 'Learn what else SalesIntel can do for your team.' }}
        </a>
      </p>
      <div class="success-progress-bar">
        <div *ngFor="let section of [1,2,3,4]; let idx = index"
             class="success-progress-section"
             [ngStyle]="getSectionStyle(idx + 1)">
          {{ levelTitles[idx] | uppercase }}
        </div>
        <div class="success-progress-icon" [style.left]="iconLeftPosition">
          <img src="../../../../../assets/images/success-center-check.svg" alt="Achievement Icon">
        </div>
      </div>
    </mat-expansion-panel>
  </ng-container>
  <ng-template #loading>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </ng-template>
</div>
<!-- Progress bar end -->
